import './wiz-title.scss';
import wiz from '../../assets/images/happy-family-day.svg';

export default function WizTitle({ title = "HAPPY" }) {
  return (
    // render svg
    <div>
    <img style={{ maxWidth: '360px', maxHeight: '100%', width: '300px', paddingBottom: '10px' }} src={wiz} alt="wiz" />
    </div>
    // <div style={{ textAlign: 'left' }}>
    //   <h1 style={{ fontSize: '80px', lineHeight: '0.7' }} className='wiz-title'>{title}</h1>
    //   <h1 style={{ fontSize: '80px', lineHeight: '0.9' }} className='wiz-title'>FAMILY DAY!</h1>
    //   <h1 style={{ fontSize: '80px', lineHeight: '0.9' }} className='wiz-title'>WIZARD</h1>
    // </div>
  );
}